import {Store} from '@ngrx/store';
import {switchMap, Observable, filter, take, map} from 'rxjs';
import {rightsSelectors} from '../selectors';

/**
 * Wait Filters Ready
 * @returns {void}
 */
export function waitFiltersReady() {
	return switchMap<any, Observable<any>>((project) =>
		(this.store as Store).select(rightsSelectors.areFiltersReady).pipe(
			filter(Boolean),
			take(1),
			map(() => project)
		)
	);
}
